// extracted by mini-css-extract-plugin
module.exports = {"list":"CardGrid_list__Gf35U","rotation":"CardGrid_rotation__a69sn"};